import moment from "moment";
import momentTimeZone from "moment-timezone";

export const formatDate = date => {
  if (!date) return "Not selected";
  return moment(date).format("MM/DD/YYYY hh:mm A");
};

export const formatDatePretty = date => {
  if (!date) return "Not selected";
  return moment(date).format("MMM DD YYYY hh:mm A");
};

export const formatDateOnlyPretty = date => {
  if (!date) return "Not selected";
  return moment(date).format("MMMM DD, YYYY");
};

export const formatDateOnlyPrettyShort = date => {
  if (!date) return "Not selected";
  return moment(date).format("MMM DD YYYY");
};

export const formatDateOnly = (date, format) => {
  if (!date) return "Not selected";
  return moment(date, format ? format : null).format("MM/DD/YYYY");
};

export const formatToMilitaryTime = time => {
  const militaryTime = new Intl.DateTimeFormat(undefined, {
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h24"
  }).format(new Date(time));
  return militaryTime == "24:00" ? "00:00" : militaryTime;
};

export const formatTimeOnly = (time, format) => {
  if (!time) return "Not selected";
  return moment(time, format ? format : null).format("hh:mm A");
};

export const formatDateOnlyMysql = (date, format) => {
  return moment(date, format ? format : null).format("YYYY-MM-DD");
};

export const formatDateISO = dateTime => {
  if (!dateTime) return null;
  if (dateTime instanceof Date || (typeof dateTime === 'string' && dateTime.includes('T'))) {
    return moment(dateTime).toISOString();
  }
  if (typeof dateTime === 'string' && /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(dateTime)) {
    return moment(dateTime, "YYYY-MM-DD HH:mm:ss").toISOString();
  }
  return moment(dateTime, "MM/DD/YYYY hh:mm A").toISOString();
};

export const formatTimeOnlyMysql = (date, format, outputFormat) => {
  return moment(date, format ? format : null).format(
    outputFormat ? outputFormat : "HH:mm:ss"
  );
};

export const formatDateTimeMysql = (date, format) => {
  return moment(date, format ? format : null).format("YYYY-MM-DD HH:mm:ss");
};

export const formatRelativeDatePretty = (today, date) => {
  if (!today || !date) {
    return "Today";
  }

  const momentToday = moment(today);
  const momentDate = moment(date);

  if (momentToday.date() == momentDate.date()) {
    return "Today";
  }

  if (momentToday.add(-1, "day").date() == momentDate.date()) {
    return "Yesterday";
  }

  return momentDate.format("LL");
};

export const getDateFromFormat = (date, format) => {
  return moment(date, format).toDate();
};

export const formatDateTimeSql = dateTime => {
  return moment(dateTime).format("YYYY-MM-DDTHH:mm:ss");
};

export const formatStartDateSql = date => {
  return date ? formatDateTimeSql(date + " 00:00:00") : null;
};

export const formatEndDateSql = date => {
  return date ? formatDateTimeSql(date + " 23:59:59") : null;
};

export const getAge = birthDate => {
  return moment().diff(birthDate, "years");
};

export const enumerateDaysBetweenDates = (startDate, endDate) => {
  var dates = [];

  var currDate = moment(startDate).startOf("day");
  var lastDate = moment(endDate).startOf("day");

  while (currDate.diff(lastDate) <= 0) {
    dates.push(currDate.clone().toDate());
    currDate.add(1, "days");
  }

  return dates;
};

export const checkDateFormat = (date, format) => {
  return moment(date, format, true).isValid();
};

export const formatSecondsToMinutes = time => {
  var minutes = Math.floor(time / 60);
  var seconds = time - minutes * 60;
  var hours = Math.floor(time / 3600);
  time = time - hours * 3600;

  return str_pad_left(minutes, "0", 2) + ":" + str_pad_left(seconds, "0", 2);
};

export const getWeekDay = date => {
  if (!date) return "";
  return moment(date).format("e");
};

export const parseNearestTime = time => {
  const parts = time.split(":");
  let hours = parseInt(parts[0]);
  let minutes = parseInt(parts[1]);
  let m = 0;
  if (minutes > 45) m = 45;
  else if (minutes > 30) m = 30;
  else if (minutes > 15) m = 15;
  let h = minutes > 52 ? (hours === 23 ? 0 : ++hours) : hours;
  return str_pad_left(h, "0", 2) + ":" + str_pad_left(m, "0", 2);
};

export const calculateDuration = (fromValue, toValue) => {
  const duration = moment.duration(moment(toValue).diff(moment(fromValue)));
  const hours = duration.asHours();
  return hours.toFixed(2);
};

export const calculateDurationInMinutes = (startDate, endDate) => {
  const duration = moment.duration(moment(endDate).diff(moment(startDate)));
  return duration.asMinutes();
};

export const formatTimeAgo = (date, currentTime) => {
  if (!date) return "Not selected";
  return moment(date).from(currentTime);
};

export const formatDateTimeDuration = (startDate, endDate, allDay = false) => {
  if (!startDate) {
    return null;
  }

  if (allDay) {
    return `${formatDateOnly(startDate)} All day`;
  }
  if (!endDate) {
    return null;
  }

  const duration = moment.duration(moment(endDate).diff(moment(startDate)));
  const durationAsMinutes = Math.round(duration.asMinutes());

  const endTime = formatTimeOnly(
    moment(startDate).add(durationAsMinutes, "minutes")
  );

  return `${formatDate(startDate)} - ${endTime} (${durationAsMinutes}min)`;
};

function str_pad_left(string, pad, length) {
  return (new Array(length + 1).join(pad) + string).slice(-length);
}

export const calculateDaysFrom = fromValue => {
  const dateFrom = moment(fromValue);
  const today = moment();
  return today.diff(dateFrom, "days");
};
export const getTimeZoneOptions = function() {
  let tm = momentTimeZone.tz.names();
  var offsetTmz = [];

  for (var i in tm) {
    offsetTmz.push({
      label:
        "(" +
        momentTimeZone.tz(tm[i]).zoneAbbr() +
        momentTimeZone.tz(tm[i]).format("Z") +
        ") " +
        tm[i],
      value: tm[i]
    });
  }
  return offsetTmz;
};
export const getTimeZoneDefault = () => {
  return momentTimeZone.tz.guess();
};
export const changeTimeZoneOptions = (dateTime, timeZone) => {
  let dateTimeZoneUtc = momentTimeZone.tz(dateTime, "UTC");
  return formatDate(dateTimeZoneUtc.clone().tz(timeZone.value));
};
